/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Whiteboard_DescInputs */

const en_of_landing_whiteboard_desc = /** @type {(inputs: Of_Landing_Whiteboard_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a shared whiteboard from a room, document, or meeting. Add notes, shapes, arrows, and drawings, then export your work.`)
};

const id_of_landing_whiteboard_desc = /** @type {(inputs: Of_Landing_Whiteboard_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka papan tulis bersama dari ruang, dokumen, atau rapat. Tambahkan catatan, bentuk, panah, dan gambar, lalu ekspor hasilnya.`)
};

/**
* | output |
* | --- |
* | "Open a shared whiteboard from a room, document, or meeting. Add notes, shapes, arrows, and drawings, then export your work." |
*
* @param {Of_Landing_Whiteboard_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_whiteboard_desc = /** @type {((inputs?: Of_Landing_Whiteboard_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Whiteboard_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_whiteboard_desc(inputs)
	return en_of_landing_whiteboard_desc(inputs)
});